import React, { useEffect } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import LazyEagerImage from "../../atoms/lazy-eager";
import "./light-box-gallery.m.css";

const LightBoxGallery = props => {
  const imageS3Key = props.element["image-s3-key"];
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <div styleName="wrapper">
      <div styleName="lightbox-gallery">
        <button onClick={props.closePopup} styleName="icon-close">
          <i className="ri-close-line" alt="close"></i>
        </button>
        <div styleName="gallery-div">
          <div styleName="right-arrow">
            {!props.hideNext &&
              <button onClick={props.goNext} styleName="icon-next">
                <i className="ri-arrow-right-s-line" alt="left"></i>
              </button>
            }
          </div>
          <div styleName="lightbox-image" className="gallery-image">
          <figure>
            <LazyEagerImage
              styleName="light-box-single-image"
              src={`https://${props.cdnImage}/${imageS3Key}`}
            />
          </figure>
            {(props.element.title || props.element["image-attribution"]) && (
              <div styleName="image-title-wrapper" className="voice-no-read">
                {props.element.title && (
                  <figcaption styleName="img-figcap" className="story-element-image-title">
                    {props.element.title}
                  </figcaption>
                )}
                {props.element["image-attribution"] && (
                  <figcaption styleName="img-figcap" className="story-element-image-title">
                    Kuva: {props.element["image-attribution"]}
                  </figcaption>
                )}
              </div>
            )}
          </div>
          <div styleName="left-arrow">
            {props.index > 0 &&
              <button onClick={props.goPrev} styleName="icon-prev">
                <i className="ri-arrow-left-s-line" alt="left"></i>
              </button>}
          </div>
        </div>
      </div>
    </div>
  )
};

LightBoxGallery.propTypes = {
  element: PropTypes.object,
  goNext: PropTypes.func,
  goPrev: PropTypes.func,
  hideNext: PropTypes.number,
  index: PropTypes.number,
  closePopup: PropTypes.func,
  cdnImage: PropTypes.string
};

function mapStateToProps(state) {
  return {
    cdnImage: get(state, ["qt", "config", "cdn-image"])
  };
}
export default connect(mapStateToProps, () => ({}))(LightBoxGallery);
